import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentPageUrl: null,
    nextPageUrl: null,
    prevPageUrl: null,
    total: 0,
    currentPageNumber: 1, // added
};

const activePageSlice = createSlice({
    name: "activePage",
    initialState,
    reducers: {
        setActivePage: (state, action) => {
            const { currentPageUrl, nextPageUrl, prevPageUrl, total, currentPageNumber } = action.payload;
            state.currentPageUrl = currentPageUrl;
            state.nextPageUrl = nextPageUrl;
            state.prevPageUrl = prevPageUrl;
            state.total = total;
            state.currentPageNumber = currentPageNumber ?? 1;
        },
        resetActivePage: (state) => {
            state.currentPageUrl = null;
            state.nextPageUrl = null;
            state.prevPageUrl = null;
            state.total = 0;
            state.currentPageNumber = 1;
        },
    },
});

export const { setActivePage, resetActivePage } = activePageSlice.actions;
export default activePageSlice.reducer;
